(function () {
    'use strict';

    angular
        .module('app')
        .factory('viewerUserSettingsService', viewerUserSettingsService);

    viewerUserSettingsService.$inject = ['$http', '$q', '$localStorage'];

    function viewerUserSettingsService($http, $q, $localStorage) {
        var localStorage = $localStorage;

        var service = {
            getViewerUserSettings: getViewerUserSettings,
            setViewerUserSettings: setViewerUserSettings,
            markupUnlockByUser: markupUnlockByUser,
            processing: false
        };

        return service;

        function getViewerUserSettings() {
            service.processing = true;
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/api/Account/ViewerUserSettings').then(function (response) {
                service.processing = false;
                deferred.resolve(response.data);
            });
            service.processing = false;
            return deferred.promise;
        }

        function setViewerUserSettings(viewerUserSettings) {
            service.processing = true;
            var request = $http({
                beforeSend: function (xhr) {
                    xhr.setRequestHeader("Content-Type", "application/json");
                },
                method: 'PUT',
                dataType: 'json',
                contentType: 'application/json',
                crossDomain: true,
                cache: false,
                url: '../Synergis.WebApi/api/Account/ViewerUserSettings',
                data: JSON.stringify(viewerUserSettings)
            }, function (err, status) {
                console.info('setViewerUserSettings error', err, status);
            });
            service.processing = false;
            return request;
        }

        // (string)ApiAccess.HttpGet("api/View/MarkupUnlockByUser");
        function markupUnlockByUser() {
            service.processing = true;
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/api/View/MarkupUnlockByUser').then(function (response) {
                service.processing = false;
                deferred.resolve(response.data);
            });
            service.processing = false;
            return deferred.promise;
        }
    }
})();